import {
  CSS,
  Flex,
  reactIcons,
  Tooltip,
  Typography,
} from '@project44/manifest-ds';

import { scopedT } from '../../../utils/functions/scopedT';
import DateDiff from '../DateDiff';
import DateTime, { DateTimeDisplayFormat } from '../DateTime';

import { DateComponentWrapper } from '../styles';

const t = scopedT();

type DateTimeType = 'carrier_reported' | 'p44_detected';

const labels: Record<DateTimeType, string> = {
  carrier_reported: t('tooltips.carrierReported'),
  p44_detected: t('tooltips.p44detected'),
};

interface ActualTimestampProps {
  actualDateTime?: string;
  css?: CSS;
  label?: string;
  format?: DateTimeDisplayFormat;
  plannedDateTime?: string;
  plannedEndDateTime?: string;
  timeZone?: string;
  type?: DateTimeType;
}

export const ActualTimestamp = ({
  actualDateTime = '',
  css,
  plannedDateTime = '',
  plannedEndDateTime = '',
  timeZone,
  format,
  label,
  type,
}: ActualTimestampProps) => {
  const tooltipTypeText = labels[type as DateTimeType] || undefined;

  const getTooltip = () => {
    switch (format) {
      case DateTimeDisplayFormat.LONG:
      case DateTimeDisplayFormat.STACKED:
        return tooltipTypeText;
      case DateTimeDisplayFormat.SHORT:
        return (
          <Flex align="center" css={{ '.middot': { color: '$text-contrast' } }}>
            {tooltipTypeText && <>{tooltipTypeText}:&nbsp;</>}
            <DateTime
              endDateTime={actualDateTime}
              format={DateTimeDisplayFormat.LONG}
              startDateTime={actualDateTime}
              timeZone={timeZone}
            />
          </Flex>
        );
    }
  };

  return (
    <DateComponentWrapper
      data-testid="actual-timestamp"
      css={{
        ...css,
      }}
    >
      <Tooltip title={getTooltip()}>
        <Typography
          variant="subtext"
          css={{ display: 'flex', alignItems: 'center' }}
        >
          <DateTime
            css={{ paddingRight: '4px' }}
            dateDiff={
              format === DateTimeDisplayFormat.STACKED && (
                <DateDiff
                  dateToCompare={actualDateTime}
                  plannedEndDate={plannedEndDateTime}
                  plannedStartDate={plannedDateTime}
                />
              )
            }
            endDateTime={actualDateTime}
            format={format}
            label={label || t('overviewLabel.actualArrival')}
            startDateTime={actualDateTime}
            startIcon={
              <reactIcons.Check
                css={{
                  width: '16px',
                  height: '16px',
                  color: '$palette-indigo-500',
                }}
              />
            }
            timeZone={timeZone}
          />
        </Typography>
      </Tooltip>
      {format !== DateTimeDisplayFormat.STACKED && (
        <DateDiff
          dateToCompare={actualDateTime}
          plannedEndDate={plannedEndDateTime}
          plannedStartDate={plannedDateTime}
        />
      )}
    </DateComponentWrapper>
  );
};

export default ActualTimestamp;
